(function () {
var root = document.querySelector('[data-wgd]');
if (!root) return;
var panels = {}, trail = ['root'], scrollY = 0;
var stack = root.querySelector('[data-wgd-stack]');
var cfg = JSON.parse(root.getAttribute('data-wgd-config') || '{}');
var openSel = cfg.burger || '.mobile-toggle,[data-wgd-open]';
var openers = document.querySelectorAll(openSel);
stack.querySelectorAll('.wgd-panel').forEach(function (p) { panels[p.dataset.panel] = p; });
function render() {
var top = trail[trail.length - 1];
Object.keys(panels).forEach(function (k) {
var s = k === top ? 'current' : (trail.indexOf(k) > -1 ? 'behind' : '');
if (s) panels[k].dataset.state = s; else panels[k].removeAttribute('data-state');
});
}
function open() {
scrollY = window.scrollY;
document.body.style.top = -scrollY + 'px';
document.body.classList.add('wgd-locked');
root.classList.add('is-open');
openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
setTimeout(function () { root.querySelector('.wgd-close').focus(); }, 280);
}
var resetFilter = function () {};
function close() {
resetFilter();
root.classList.remove('is-open');
document.body.classList.remove('wgd-locked');
document.body.style.top = '';
window.scrollTo(0, scrollY);
openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
setTimeout(function () { trail = ['root']; render(); }, 300);
}
if (cfg.hijack !== false) {
document.addEventListener('click', function (e) {
if (!e.target.closest) return;
var t = e.target.closest(openSel);
if (!t) return;
e.preventDefault();
e.stopImmediatePropagation();
if (root.classList.contains('is-open')) close(); else open();
}, true);
}
root.querySelector('.wgd-close').addEventListener('click', close);
root.querySelector('.wgd-scrim').addEventListener('click', close);
stack.addEventListener('click', function (e) {
var o = e.target.closest('[data-wgd-panel-open]');
if (o) { trail.push(o.getAttribute('data-wgd-panel-open')); render(); return; }
if (e.target.closest('[data-wgd-back]')) { if (trail.length > 1) { trail.pop(); render(); } }
});
document.addEventListener('keydown', function (e) {
if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
if (trail.length > 1) { trail.pop(); render(); } else close();
});
root.addEventListener('keydown', function (e) {
if (e.key !== 'Tab') return;
var all = root.querySelectorAll('a[href],button,input,[tabindex]:not([tabindex="-1"])');
var vis = [];
for (var i = 0; i < all.length; i++) if (all[i].offsetParent !== null) vis.push(all[i]);
if (!vis.length) return;
var f = vis[0], l = vis[vis.length - 1];
if (e.shiftKey && document.activeElement === f) { e.preventDefault(); l.focus(); }
else if (!e.shiftKey && document.activeElement === l) { e.preventDefault(); f.focus(); }
});
var input = root.querySelector('[data-wgd-filter]');
if (input) {
var list = root.querySelector('[data-wgd-schoollist]');
var rows = list.querySelectorAll('.wgd-row');
var heads = list.querySelectorAll('[data-wgd-group]');
var empty = root.querySelector('[data-wgd-empty]');
var termA = root.querySelector('[data-wgd-term]');
var termB = root.querySelector('[data-wgd-term-2]');
var alt = root.querySelector('[data-wgd-alt]');
var timer;
var firstAlpha = list.querySelector('.wgd-alpha');
var pinned = [];
if (firstAlpha) {
for (var pi = 0; pi < rows.length; pi++) {
if (firstAlpha.compareDocumentPosition(rows[pi]) & Node.DOCUMENT_POSITION_PRECEDING) {
pinned.push(rows[pi]);
}
}
}
var isPinned = function (el) { return pinned.indexOf(el) > -1; };
resetFilter = function () {
if (!input.value) return;
input.value = '';
if (empty) { empty.classList.remove('sent'); }
input.dispatchEvent(new Event('input', { bubbles: true }));
};
input.addEventListener('input', function (e) {
var q = e.target.value.trim().toLowerCase(), hits = 0, i;
for (i = 0; i < rows.length; i++) {
var name = rows[i].getAttribute('data-name') || '';
var show = q ? (!isPinned(rows[i]) && name.indexOf(q) > -1) : true;
rows[i].style.display = show ? '' : 'none';
if (show) hits++;
}
for (i = 0; i < heads.length; i++) heads[i].style.display = q ? 'none' : '';
if (!empty) return;
empty.style.display = hits ? 'none' : 'block';
if (hits || !q) return;
var raw = e.target.value.trim(), shown = '"' + raw + '"';
if (termA) termA.textContent = shown;
if (termB) termB.textContent = shown;
if (alt) alt.href = '/search?q=' + encodeURIComponent(raw);
empty.classList.remove('sent');
if (raw.length < 3) return;
clearTimeout(timer);
timer = setTimeout(function () {
try {
window._learnq = window._learnq || [];
window._learnq.push(['track', cfg.missEvent || 'School Not Found', { term: raw }]);
} catch (err) {}
}, 900);
});
var form = root.querySelector('[data-wgd-notify]');
if (form) {
form.addEventListener('submit', function (e) {
e.preventDefault();
var email = form.querySelector('input[type=email]').value.trim();
var term = input.value.trim();
if (!email) return;
empty.classList.add('sent');
try {
window._learnq = window._learnq || [];
window._learnq.push(['identify', { $email: email, requested_school: term }]);
window._learnq.push(['track', 'Requested School', { term: term }]);
} catch (err) {}
});
}
}
render();
})();
